/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {prepareRecoveryActivities} from '../api'

export const useMutationPrepareRecoveryActivities = createReactQueryMutationHook('prepareRecoveryActivities', prepareRecoveryActivities)
